import { axiosBase } from '@/services/axios-base';
import { HRMAccountTeamDTO, HRMActivityDTO, HRMProjectDTO, HRMUserEngagementTimeSheetDTO } from '@/models';

export const fetchHRMMemberTimeSheets = (
  projectAssessmentId: number
): Promise<{ data: HRMUserEngagementTimeSheetDTO[] }> => {
  return axiosBase.get(`/api/assessment/${projectAssessmentId}/hrmUserEngagements`);
};

export const fetchEditedHRMTimeSheets = (
  projectAssessmentId: number
): Promise<{ data: HRMUserEngagementTimeSheetDTO[] }> => {
  return axiosBase.get(`/api/assessment/${projectAssessmentId}/hrmTimeSheets`);
};

export const fetchHRMProjects = (): Promise<{ data: HRMProjectDTO[] }> => {
  return axiosBase.get('/api/hrm/projects');
};

export const fetchAllActivities = (): Promise<{ data: HRMActivityDTO[] }> => {
  return axiosBase.get('/api/hrm/activities');
};

export const fetchHRMAccountTeams = (): Promise<{ data: HRMAccountTeamDTO[] }> => {
  return axiosBase.get('/api/hrm/account-teams');
};
